import { render, staticRenderFns } from "./AgeCheckerGB.vue?vue&type=template&id=40aa9333&"
import script from "./AgeCheckerGB.vue?vue&type=script&lang=js&"
export * from "./AgeCheckerGB.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports